
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/retail-investor/financial-highlight",
      function () {
        return require("private-next-pages/retail-investor/financial-highlight.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/retail-investor/financial-highlight"])
      });
    }
  